//#region IMPORT
import React from 'react';
import { Box, Stack } from '@mui/material';
import M_TBG_CUSTOM_01F from '../M_TBG_CUSTOM_01/M_TBG_CUSTOM_01F';
import M_TBG_CUSTOM_02F from '../M_TBG_CUSTOM_02/M_TBG_CUSTOM_02F';
import M_TBG_CUSTOM_03F from '../M_TBG_CUSTOM_03/M_TBG_CUSTOM_03F';
import M_TBG_CUSTOM_04F from '../M_TBG_CUSTOM_04/M_TBG_CUSTOM_04F';
import M_TBG_CUSTOM_05F from '../M_TBG_CUSTOM_05/M_TBG_CUSTOM_05F';
import M_TBG_CUSTOM_06F from '../M_TBG_CUSTOM_06/M_TBG_CUSTOM_06F';
import M_TBG_CUSTOM_07F from '../M_TBG_CUSTOM_07/M_TBG_CUSTOM_07F';
import M_TBG_CUSTOM_08F from '../M_TBG_CUSTOM_08/M_TBG_CUSTOM_08F';
import M_TBG_CUSTOM_09F from '../M_TBG_CUSTOM_09/M_TBG_CUSTOM_09F';
//#endregion

function CustomLineStepper({ activeStep, steps }) {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
        px: 2,
        py: 2,
      }}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <Box
          key={index}
          sx={{
            flex: 1,
            height: 4,
            backgroundColor: index <= activeStep ? '#33ABD1' : '#e0e0e0',
            borderRadius: 2,
            ml: index === 0 ? 0 : 1,
          }}
        />
      ))}
    </Box>
  );
}

function M_TBG_CUSTOM(props) {
  const components = [
    // 영상 교육
    <M_TBG_CUSTOM_01F
      key="01"
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      startTimeRef={props.startTimeRef}
      tbmCdRef={props.tbmCdRef}
      ActiveButton={props.ActiveButton}
    />,
    // 중간 다이어로그
    <M_TBG_CUSTOM_02F
      key="02"
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      check={props.check}
      setCheck={props.setCheck}
      tbmCdRef={props.tbmCdRef}
      startTimeRef={props.startTimeRef}
      ActiveButton={props.ActiveButton}
    />,
    // pdf 교육
    <M_TBG_CUSTOM_03F
      key="03"
      tbmCdRef={props.tbmCdRef}
      ActiveButton={props.ActiveButton}
    />,
    // 작업계획서
    <M_TBG_CUSTOM_04F key="04" ActiveButton={props.ActiveButton} />,
    // 작업허가서
    <M_TBG_CUSTOM_05F key="05" ActiveButton={props.ActiveButton} />,
    // 중간 다이어로그
    <M_TBG_CUSTOM_06F
      key="06"
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      check={props.check}
      setCheck={props.setCheck}
      addMeetingFlag={props.addMeetingFlag}
      setAddMeetingFlag={props.setAddMeetingFlag}
      tbmCdRef={props.tbmCdRef}
      startTimeRef={props.startTimeRef}
      ActiveButton={props.ActiveButton}
    />,
    // 추가 회의
    <M_TBG_CUSTOM_07F
      key="07"
      tbmCdRef={props.tbmCdRef}
      startTimeRef={props.startTimeRef}
    />,
    // TBM 회의
    <M_TBG_CUSTOM_08F
      key="08"
      addMeetingFlag={props.addMeetingFlag}
      setAddMeetingFlag={props.setAddMeetingFlag}
      tbmCdRef={props.tbmCdRef}
      ActiveButton={props.ActiveButton}
    />,
    // TBM 완료
    <M_TBG_CUSTOM_09F
      key="09"
      tbmCdRef={props.tbmCdRef}
      TbmEnd={props.TbmEnd}
    />,
  ];

  return (
    <Box sx={{ backgroundColor: '#F3F7F8', height: 'calc(100vh - 56px)' }}>
      <Stack sx={{ width: '100%', height: '100%' }}>
        <CustomLineStepper
          activeStep={props.activeStep}
          steps={components.length}
        />
        {components[props.activeStep] || null}
      </Stack>
    </Box>
  );
}

export default M_TBG_CUSTOM;
